import { render, staticRenderFns } from "./UpdateQuestionsModal.vue?vue&type=template&id=7bf866b0&"
import script from "./UpdateQuestionsModal.vue?vue&type=script&lang=js&"
export * from "./UpdateQuestionsModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateQuestionsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {Template: require('/lasso/components/templates/Template.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bf866b0')) {
      api.createRecord('7bf866b0', component.options)
    } else {
      api.reload('7bf866b0', component.options)
    }
    module.hot.accept("./UpdateQuestionsModal.vue?vue&type=template&id=7bf866b0&", function () {
      api.rerender('7bf866b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/shared/UpdateQuestionsModal.vue"
export default component.exports